<template>
  <div class="feed">

    <keep-alive>
      <NavigationBar id="rulesNavigationBarId" ref="rulesNavigationBarRef">
        <template v-slot:center>
          Feed
        </template>
      </NavigationBar>
    </keep-alive>

    <!-- Tabbar (for Dashboard & Feed) -->
    <div class="navigation__tabbar">
      <router-link to="" class="navigation__tabbar__item">
        <div class="navigation__tabbar__item__label">
          Dashboard
        </div>
      </router-link>
      <router-link to="" class="navigation__tabbar__item navigation__tabbar__item-active">
        <div class="navigation__tabbar__item__label">
          Feed
          <span>3</span>
        </div>
      </router-link>
    </div>

    <!-- Chat -->
    <div class="chat">

      <div class="chat__gradient"></div>

      <ChatInput @textEntered="textEntered"></ChatInput>

      <!-- Chat Content -->
      <div class="chat__content">
        
        <ChatItem v-for="chatItem in chatItems" :reacted="chatItem.reactions.length > 0" :key="chatItem.id" @itemClicked="openContextMenu(chatItem)" :chatItem="chatItem"></ChatItem>

      </div>

    </div>
    
    <ChatContextMenu :show-modal="showModal" :chat-item="selectedChatItem" @emojiClicked="closeContextMenu"></ChatContextMenu>
    
  </div>
</template>

<script>

import NavigationBar from '../components/NavigationBar'
import ChatInput from '../components/chat/ChatInput'
import ChatItem from '../components/chat/ChatItem'
import ChatContextMenu from '../components/chat/ChatContextMenu.vue'
import axios from 'axios'
import { TOAST_DURATION } from '@/main'

export default {
  name: 'Feed',
  components: { NavigationBar, ChatInput, ChatItem, ChatContextMenu },
  data () {
    return {
      showModal: false,
      selectedChatItem: {},
      chatItems: [
        { id: 1, sender: false, reacted: false, reactions: [], userid: 10, username: 'Michael Müller', time: new Date('04-25-2024 14:03:44'), text: 'Wartet mal ab. Heute Abend hole ich mir erstmal den richtigen Tipp ✌' },
        { id: 2, sender: false, reacted: true, reactions: [], userid: 11, username: 'Stefan Sinns', time: new Date('04-25-2024 15:03:44'), text: 'Keine Chance! Du wirst hier nix mehr holen.' },
        { id: 3, sender: false, reacted: false, reactions: [], userid: 12, username: 'Philipp Fromm', time: new Date('04-25-2024 15:43:44'), text: 'Was für ein Quatsch 😅 Wartet mal ab. Ich hol mir noch die Spieltagskrone.' }
      ]
    }
  },
  mounted() {
    if(!this.isSPMUser() || !this.$store.getters.loggedIn) {
      this.$router.push({ name: 'dashboard' }).catch(err => {})
    }
    
    if(this.$store.state.betgame.chat && this.$store.state.betgame.chat !== '' && this.$store.state.chat_token && this.$store.state.chat_token !== '') {

      /*
      ChatAPIService.getConversation(this.$store.state.chat_token, this.$store.state.betgame.chat)
      .then(response => {
        Vue.$log.debug('ChatAPIService.getConversation ' + JSON.stringify(response.data))
        const temp = JSON.parse(response.data)
        for (let i = 0; i < temp.length; i++) {
          this.chatItems.unshift({
            id: this.chatItems.length + 1,
            sender: this.$store.state.user.id === parseInt(temp[i].user_id),
            reacted: false,
            reactions: [],
            username: this.$store.getters.getUserById(parseInt(temp[i].user_id)).nickname,
            userid: parseInt(temp[i].user_id),
            time: new Date(temp[i].timestamp * 1000),
            text: temp[i].text
          })
        }
        this.chatItems.sort((a, b) => b.time - a.time)
        chatstore.dispatch('setChatItems', this.chatItems).then(() => {
          
        })
      })
      .catch(error => {
        Vue.$log.debug('ChatAPIService.getConversation ' + error)
      })
    }
      */
      
      const uid = this.$store.state.user.id
      const cid = this.$store.state.betgame.chat
      const token = this.$store.state.chat_token
      
      axios.get('https://chat.teamtip.net/conversation/list/' + cid + '/0/10', {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .then(({ data }) => {
        const temp = JSON.parse(data)
        for(let i = 0; i < temp.length; i++) {
          this.chatItems.unshift({ id: this.chatItems.length + 1, sender: this.$store.state.user.id === parseInt(temp[i].user_id), 
            reacted: false, reactions: [], username: this.$store.getters.getUserById(parseInt(temp[i].user_id)).nickname, 
            userid: parseInt(temp[i].user_id),
            time: new Date(Math.round(temp[i].timestamp * 1000)), text: temp[i].text })
        }
        this.chatItems.sort((a, b) => b.time - a.time)
      })
      .catch(function (error) {
        axios.post('https://chat.teamtip.net/conversation/add_participant',
            'user_id=' + uid + '&conversation_id=' + cid,
            {headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
              }}
        )
        .then(({ result }) => {
          console.log('https://chat.teamtip.net/conversation/add_participant ok ' + JSON.stringify(result))
        })
        .catch(function (error) {
          console.log('https://chat.teamtip.net/conversation/add_participant error ' + JSON.stringify(error))
        })
      })
    }
      
    if(this.$store.state.betgame && this.$store.state.chat_token && this.isAdmin(this.$store.state.betgame.id)) {
      if(!this.$store.state.betgame.chat || this.$store.state.betgame.chat === '') {
        const data = {
          'title': this.$store.state.betgame.name,
          'participant_ids': [
            '' + this.$store.state.user.id
          ]
        }
        axios.post('https://chat.teamtip.net/conversation/create',
            data,
                {headers: {
                'Authorization': 'Bearer ' + this.$store.state.chat_token,
                'Content-Type': 'application/json; charset=utf-8'
              }}
        )
        .then(({ data }) => {
          const temp = JSON.parse(data)
          this.updateBetgame({ chat: temp._id })
        })
        .catch(function (error) {
        })
      }
    }
  },
  methods: {
    isAdmin(betgame) {
      const t = this.$store.state.betgames_owner.filter(function (item) {
        return item.id === betgame
      });
      return t.length > 0
    },
    updateBetgame (data) {
      this.$store.dispatch('patchBetgame', data)
      .then(() => {
        this.$toast.open({ message: this.$i18n.t('create_chat_success'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'success'
        })
      })
      .catch(function (error) {
        this.$toast.open({ message: this.$i18n.t('create_chat_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      })
      .finally(function () {
      })
    },
    openContextMenu(item) {
      this.selectedChatItem = item
      this.showModal = true
    },
    closeContextMenu(item) {
      this.showModal = false
      if(item && item.selected) {
        if(this.selectedChatItem.reactions.includes(item.selected)) {
          this.selectedChatItem.reactions = this.selectedChatItem.reactions.filter(reaction => reaction !== item.selected)
        } else {
          this.selectedChatItem.reactions.push(item.selected)
        }
      }
    },
    textEntered(text) {
      axios.post('https://chat.teamtip.net/conversation/message/' + this.$store.state.betgame.chat, 
        text
      , {headers: {
          'Authorization': 'Bearer ' + this.$store.state.chat_token,
          'Content-Type': 'application/json; charset=utf-8'
        }}
      )
      .then(({ data }) => {
      })
      .catch(function (error) {
      })
      this.chatItems.unshift({ id: this.chatItems.length + 1, sender: true, reacted: false, reactions: [], 
        username: this.$store.state.user.nickname, userid: this.$store.state.user.id, time: new Date(), text: text.text })
    },
  },
  computed: {}
}
</script>

<style lang="scss">

  /*.chat__context {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: auto;
    max-width: 576px;

    @media screen and (min-width: 768px) {
      margin: auto;
    }

    &__message {
      background: $colorWhite;
      padding: 21px 24px 18px;
      border-radius: 4px 24px 24px 24px;

      &__title {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        color: $colorGreyDark;
        margin-bottom: 8px;

        .chat__item--sender & {
          color: $colorWhite;
        }

        span {
          margin-top: 3px;
          font-size: 11px;
          font-weight: 400;
          opacity: .48;
          margin-left: auto;
        }
      }

      p {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }*/
</style>

<style lang="scss" scoped>
  /*.chat__contextmenu {
    padding: 0 16px;

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }*/

  .feed {
    max-width: 768px;
    margin: 0px auto;
  }

  .navigation__tabbar {
    position: sticky;
    top: 63px;
    z-index: 500;
    display: flex;
    justify-content: center;
    background: $colorWhite;
    width: 100vw;
    margin: -1px -16px 0;
    box-shadow: inset 0 -1px rgba($colorGreyDark, .24);

    @media screen and (min-width: 768px) {
      margin: -1px calc((100vw - 768px) / -2) 0;
    }

    &__item {
      display: flex;
      justify-content: center;
      width: calc(768px / 2);
      padding: 12px 0;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: $colorGreyDark;
      text-decoration: none;

      &-active {
        color: var(--color-primary);
        box-shadow: inset 0 -2px 0 0 var(--color-primary);
      }

      &__label {
        position: relative;

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          content: '';
          top: -10px;
          right: -16px;
          min-width: 16px;
          height: 16px;
          padding: 0.5px 0 0 1px;
          border-radius: 8px;
          font-size: 10px;
          font-weight: 500;
          color: $colorWhite;
          background: $colorLive;
          box-sizing: border-box;
        }
      }
    }
  }

  .chat {
    position: relative;
    margin: 0 -16px;

    &__gradient {
      position: sticky;
      z-index: 1;
      top: calc(64px + 43px);
      left: 0;
      width: 100%;
      height: 84px;
      margin-bottom: -84px;
      background: linear-gradient(180deg, $colorBackground 20%, rgba($colorBackground, 0) 100%);
    }

    &__content {
      display: flex;
      flex-direction: column;
      padding: 0 12px;
    }

  }
</style>
